<template>
  <div>
    <v-card class="pa-5 rounded-lg" flat>
      <v-row no-gutters class="pa-2">
        <v-col cols="12" md="10">
          <title-page
            back="true"
            colorIconBack="#006341"
            :title="`Mentor ${nameMeeting} Evaluation`"
          />
        </v-col>
        <v-col
          cols="12"
          md="2"
          v-if="permissions.includes('MENTOR') && role == 'VENDOR'"
        >
          <v-btn
            class="btn"
            @click="createData"
            block
            depressed
            color="#016443"
            dark
          >
            + Add Data
          </v-btn>
        </v-col>
      </v-row>
      <v-row no-gutters align="center">
        <v-col cols="12" md="10">
          <div class="pa-2">
            <v-card style="background-color: #016443; padding: 2px">
              <v-text-field
                placeholder="Search Evaluation"
                solo
                v-model="find"
                hide-details
                dense
                prepend-inner-icon="mdi-magnify"
                flat
              ></v-text-field>
            </v-card>
          </div>
        </v-col>
        <v-col cols="12" md="2">
          <div class="pa-2">
            <v-btn
              block
              depressed
              color="#016443"
              dark
              class="mr-2 px-2"
              @click="fetchData"
            >
              <h5>Search</h5>
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <v-skeleton-loader type="table-tbody" v-if="loading"></v-skeleton-loader>
      <div v-if="dataSet && !loading">
        <v-data-table
          :headers="headers"
          :items="dataSet"
          :page.sync="page"
          :items-per-page="limit"
          class="elevation-0 color_txt"
          hide-default-footer
          :single-select="false"
        >
          <template v-slot:[`item.name`]="{ item }">
            <router-link class="opener_name" :to="`/scholar/${item.user_id}`">
              <p class="mb-0 black--text">{{ item.name }}</p>
            </router-link>
          </template>
          <template v-slot:[`item.updated_at`]="{ item }">
            <h5 style="font-weight: normal">
              {{ $date(item.created_at).format("MMM DD, YYYY") }}
            </h5>
          </template>
          <template v-slot:[`item.approval`]="{ item }">
            <div class="d-flex">
              <v-card
                class="pa-2"
                flat
                :color="
                  item.approval == 'approved'
                    ? '#006341'
                    : item.approval == 'declined'
                    ? '#FE0404'
                    : item.approval == 'revision'
                    ? '#001A72'
                    : '#B3A369'
                "
              >
                <h4
                  style="
                    color: white;
                    text-transform: uppercase;
                    text-align: center;
                  "
                >
                  {{ item.approval }}
                </h4>
              </v-card>
            </div>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex">
              <v-btn class="mr-2" icon @click="updateData(item)">
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </div>
      <div class="text-center my-2 pa-3" v-if="dataSet">
        <v-pagination
          v-model="page"
          color="#006341"
          @input="fetchData"
          :length="last_page"
        ></v-pagination>
      </div>
    </v-card>
    <dialog-large
      :d_large="d_large"
      @refetch="fetchData"
      @close="d_large = false"
      :inventory="inventory"
      :type="d_type"
      :title="d_title"
      line="true"
    />
  </div>
</template>

<script>
import dialogLarge from "../../../dialog/dialogLarge.vue";
import { mapState } from "vuex";
import TitlePage from "../../../../components/atom/titlePage.vue";
export default {
  computed: {
    ...mapState({
      role: (state) => state.role,
      permissions: (state) => state.permissions,
    }),
  },
  components: { dialogLarge, TitlePage },
  name: "listEvaluationMentor",
  props: ["viewType"],
  data() {
    return {
      start: true,
      loading: false,
      error: "",
      find: "",
      d_large: false,
      inventory: "",
      d_type: "",
      d_title: "",
      nameMeeting: "",
      dataScholar: [],
      dataSet: null,
      page: 1,
      limit: 10,
      headers: [
        {
          text: "Name",
          align: "start",
          value: "name",
        },
        {
          text: "ID",
          align: "start",
          value: "no_tf",
        },
        {
          text: "Attende",
          align: "start",
          value: "attendance",
        },
        { text: "Actions", sortable: false, value: "actions" },
      ],
    };
  },
  mounted() {
    this.fetchDataSchedule();
    this.fetchData();
    this.fetchDataScholar();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let tempPath = `schedule/review?user_id=${this.$route.params.idUser}&course_schedule_administrator_id=${this.$route.params.idSchedule}`;
      if (!this.permissions.includes("MENTOR") || this.role === "SUPERADMIN") {
        tempPath = `schedule/review?course_schedule_administrator_id=${this.$route.params.idSchedule}`;
      }
      let data = {
        path: tempPath,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSet = data.data;
          this.total = data.total;
          this.last_page = data.last_page;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    fetchDataSchedule() {
      let data = {
        path: `schedule/administrator?filter[id]=${this.$route.params.idSchedule}`,
      };
      this.$store.dispatch("user/getUser", data).then((data) => {
        this.nameMeeting = data.data[0].title;
      });
    },
    fetchDataScholar() {
      let data = {
        path: `course/mentor?sort=-created_at&include=dataMentor,dataScholar&filter[course_id]=${this.$route.params.idCourse}`,
      };
      this.$store.dispatch("user/getUser", data).then((data) => {
        this.dataScholar = [];
        data.data.forEach((item) => {
          if (item.data_scholar) {
            this.dataScholar.push({
              name: item.data_scholar.name,
              id: item.scholar_id,
            });
          }
        });
      });
    },
    createData() {
      this.inventory = { optScholar: this.dataScholar };
      this.d_type = "c_evaluation";
      this.d_title = "Mentor Meetings Evaluation";
      this.d_large = true;
    },
    updateData(item) {
      this.inventory = { optScholar: this.dataScholar, data: item };
      this.d_type = "u_evaluation";
      this.d_title = "Mentor Meetings Evaluation";
      this.d_large = true;
    },
  },
};
</script>

<style></style>
